var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_352_4403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7457 0H5.25412C3.28916 0.001875 1.6967 1.59434 1.69482 3.55934V16.4407C1.6967 18.4057 3.28916 19.9982 5.25416 20H14.7457C16.7107 19.9982 18.3031 18.4057 18.305 16.4407V3.55934C18.3031 1.59434 16.7106 0.001875 14.7457 0ZM9.9999 15.1966H5.93209C5.46404 15.1966 5.08463 14.8172 5.08463 14.3491C5.08463 13.8811 5.46404 13.5017 5.93209 13.5017H9.9999C10.4679 13.5017 10.8474 13.8811 10.8474 14.3491C10.8474 14.8172 10.4679 15.1966 9.9999 15.1966ZM14.0677 10.9051H5.93209C5.46404 10.9051 5.08463 10.5257 5.08463 10.0576C5.08463 9.58957 5.46404 9.21016 5.93209 9.21016H14.0677C14.5357 9.21016 14.9151 9.58957 14.9151 10.0576C14.9151 10.5257 14.5357 10.9051 14.0677 10.9051ZM14.0677 6.49832H5.93209C5.46404 6.49832 5.08463 6.11891 5.08463 5.65086C5.08463 5.18281 5.46404 4.8034 5.93209 4.8034H14.0677C14.5357 4.8034 14.9151 5.18281 14.9151 5.65086C14.9152 6.11887 14.5357 6.49832 14.0677 6.49832Z",
    fill: "#99A0A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_352_4403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step3.258ed815224a578900bcd0861e41029d.svg";
export { ForwardRef as ReactComponent };